import StyledButton from "../../buttons/StyledButton";
import BaseModal from "../BaseModal/BaseModal";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import styles from "./ConfirmationModal.module.css";

const strings = {
  title: "Confirmation",
  message: "Are you sure you want to proceed?",
  yesContinue: "Yes, Continue",
  noCancel: "Cancel",
};

type Props = {
  isOpen: boolean;
  title?: string;
  message?: string;

  cancelText?: string;
  onRequestClose: () => void;

  confirmText?: string;
  onConfirm?: () => void;
};

export default function ConfirmationModal({
  isOpen,
  onRequestClose,

  title = strings.title,
  message = strings.message,
  confirmText = strings.yesContinue,
  cancelText = strings.noCancel,

  onConfirm,
}: Props) {
  return (
    <BaseModal
      className={styles.modal}
      isOpen={isOpen}
      label={title}
      onRequestClose={onRequestClose}
    >
      <div className={styles.header}>
        <h1 className={styles.title}>{title}</h1>
        <ModalCloseButton onClick={onRequestClose} />
      </div>
      <div className={styles.body}>{message}</div>
      <div className={styles.footer}>
        <StyledButton
          variant="primary"
          className={styles.button}
          onClick={onRequestClose}
        >
          {cancelText}
        </StyledButton>
        {onConfirm && (
          <StyledButton
            variant="danger"
            className={styles.button}
            onClick={onConfirm}
          >
            {confirmText}
          </StyledButton>
        )}
      </div>
    </BaseModal>
  );
}
